<template>
  <div>
    <surveys-table
      surveyName="NRS"
      surveyCode="NRS"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_NRS,
        viewDetail: permissions.SEE_DETAIL_SURVEY_NRS,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
